import React from 'react'

function Waiting() {
  return <i className="fas fa-spinner fa-spin"></i>
}

export default Waiting
